module.exports = __webpack_public_path__ + "static/media/rendimiento esperado-gris_old.e276b3f0.svg";